import { Flex, Grid, GridItem, MenuItem, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { OrganizationRoleType } from "../../../../autogen/bff-api";
import { useGrantRoleName } from "../../../../pages/organizations/current/manage-users/useGrantRoleName";
import { ProfileImageRounded } from "../../../../pages/sourcing-events/buyer/view-all/ProfileImageRounded";
import { urls } from "../../../../urls";
import { useLoggedInWithOrgContextState } from "../../../auth/useLoggedInWithOrgContextState";
import { displayWrappedWithEllipsis } from "../../../formatting/displayWrappedWithEllipsis";

export const PersonalProfileMenuItem = () => {
  const navigate = useNavigate();
  const authState = useLoggedInWithOrgContextState();
  const fullName = `${authState.me.firstName} ${authState.me.lastName}`;
  const { t } = useTranslation();
  const grantRoleName = useGrantRoleName();

  const roleToName = (role: OrganizationRoleType): string => {
    switch (role) {
      case OrganizationRoleType.Admin:
        return t("Administrator");
      case OrganizationRoleType.Owner:
        return t("Organization owner");
      case OrganizationRoleType.SourcingCreator:
        return t("Sourcing Creator");
      case OrganizationRoleType.SourcingViewer:
        return t("Sourcing Viewer");
      case OrganizationRoleType.ContractCreator:
        return t("Contract Creator");
      case OrganizationRoleType.ContractViewer:
        return t("Contract Viewer");
      case OrganizationRoleType.ProjectCreator:
        return t("Project Creator");
      case OrganizationRoleType.ProjectViewer:
        return t("Project Viewer");
    }
  };

  const roleNames = [
    ...authState.selectedOrg.roles.map(roleToName),
    ...authState.selectedOrg.departmentRoles.map(
      (departmentRole) => `${grantRoleName(departmentRole.role)} (${departmentRole.departmentName})`
    ),
  ];

  return (
    <MenuItem
      onClick={() => {
        navigate(urls.myProfile.personal.view);
      }}
    >
      <Grid
        h="100%"
        gridTemplateColumns={`60px 2fr`}
        gridTemplateRows={`20px 20px`}
        templateAreas={`
                "image name"
                "image email"
                "image role"
                `}
        pb="9px"
        pt="5px"
      >
        <GridItem area="image" display={"flex"} alignItems="center">
          <Flex pt="3px">
            <ProfileImageRounded name={authState.me.firstName ?? undefined} backgroundColor="smPrimary" width="50px" />
          </Flex>
        </GridItem>
        <GridItem area="name">
          <Text fontSize="md">
            <b>{displayWrappedWithEllipsis(fullName, 30)}</b>
          </Text>
        </GridItem>
        <GridItem area="email">
          <Text fontSize="sm" color="smMuted">
            {displayWrappedWithEllipsis(authState.me.email, 30)}
          </Text>
        </GridItem>
        <GridItem area="role">
          <Text fontSize="sm">{roleNames.join(", ")}</Text>
        </GridItem>
      </Grid>
    </MenuItem>
  );
};
